"use client";

import { Tweet } from "react-tweet";

export default function ClientSideTweet({ id }: { id: string }) {
  return <Tweet id={id} />;
}

